var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2557 10.0472L9.34449 10.6156C7.37779 9.62128 6.16327 8.4788 5.45633 6.69813L6.00067 3.75647L4.97208 1H2.32035C1.52293 1 0.895164 1.66383 1.01464 2.45801C1.31155 4.44025 2.18815 8.03506 4.74939 10.6156C7.43929 13.3258 11.314 14.5017 13.4461 14.9697C14.2697 15.1499 15 14.5032 15 13.6534V11.1007L12.2557 10.0472Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephone);
export default __webpack_public_path__ + "static/media/telephone.358341022c83d3e7577da6dcd51fa8a3.svg";
export { ForwardRef as ReactComponent };